import licenceRecordApi from '../services/api/licenceRecordApi';
import { refreshSessionUser } from '../services/auth';
import { setAlert } from './alerts';

export const SESSION_USER_UPDATED = 'SESSION/SESSION_USER_UPDATED';
export const SELECTED_LICENCE_REFRESHED = 'SESSION/SELECTED_LICENCE_REFRESHED';
export const TOGGLE_UPDATING_LICENCE = 'SESSION/TOGGLE_UPDATING_LICENCE';
export const RESET_APP_STATE = 'SESSION/RESET_APP_STATE';

export const sessionUserUpdated = (user) => ({
    type: SESSION_USER_UPDATED,
    user,
});

export const resetAppState = () => ({
    type: RESET_APP_STATE,
});

export const selectedLicenceRefreshed = (selectedLicence) => ({
    type: SELECTED_LICENCE_REFRESHED,
    selectedLicence,
});

export const toggleUpdatingLicence = (isUpdatingLicence) => ({
    type: TOGGLE_UPDATING_LICENCE,
    isUpdatingLicence,
});

export const updateLicenceRecord = (licenceType) => async (dispatch) => {
    try {
        dispatch(toggleUpdatingLicence(true));
        await licenceRecordApi.update(licenceType);

        const sessionUser = await refreshSessionUser();
        dispatch(sessionUserUpdated(sessionUser));
        dispatch(selectedLicenceRefreshed(null));
    } catch ({ response }) {
        dispatch(setAlert('Unable to update licence agreement.', 'error'));
    } finally {
        dispatch(toggleUpdatingLicence(false));
    }
};
